const local = {
  SITE_URL: 'http://localhost:8000',
  API_URL: 'http://localhost:8000/api/v1/',
  WEBSOCKET_URL: 'ws://localhost:8000/ws',
};

export { local as default };
